module.exports = "/_next/static/images/blurred-background-4158x2334-3f64378cc13ce2bf4a37bc4deaf1de09.jpg";